import { gridClasses } from '@mui/x-data-grid-pro'

export const gridHeaderStyling = {
  [`.${gridClasses.columnHeader}:focus`]: { outline: 'none' },
  [`.${gridClasses.columnHeader}:focus-within`]: { outline: 'none' },
  [`.${gridClasses.cell}:focus`]: { outline: 'none' },
  [`.${gridClasses.headerFilterRow}`]: { borderTop: 'none' }
}
